import { gql } from '@apollo/client'

export const GET_USER_FOLLOWS = gql`
  query {
    getUserFollows {
      campaign_id
      id
      user_id
    }
  }
`
